/* LiftPro — vehicle fitment cascade (Make -> Model -> Generation/Years).
 *
 * Data source: window.LiftProVehicles (Storefront API metaobjects, cached;
 * falls back to the JSON asset fitment-tree.json regenerated on catalog import).
 * Selected vehicle is kept in localStorage and applied on collection pages
 * as a fit_<generation-handle> tag filter.
 */
(function () {
  "use strict";

  var LS_KEY = "liftpro_vehicle";

  function readVehicle() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function saveVehicle(v) {
    try {
      if (v) localStorage.setItem(LS_KEY, JSON.stringify(v));
      else localStorage.removeItem(LS_KEY);
    } catch (e) { /* private mode */ }
  }

  function fillSelect(sel, items, placeholder) {
    sel.innerHTML = "";
    var opt = document.createElement("option");
    opt.value = "";
    opt.textContent = placeholder;
    sel.appendChild(opt);
    (items || []).forEach(function (it) {
      var o = document.createElement("option");
      o.value = it.h;
      o.textContent = it.n;
      sel.appendChild(o);
    });
  }

  function findBy(list, h) {
    for (var i = 0; i < (list || []).length; i++) {
      if (list[i].h === h) return list[i];
    }
    return null;
  }

  function vehicleFromPath(tree) {
    var m = window.location.pathname.match(/\/fit_([a-z0-9-]+)/);
    if (!m) return null;
    var genH = m[1];
    for (var i = 0; i < tree.makes.length; i++) {
      var make = tree.makes[i];
      for (var j = 0; j < make.models.length; j++) {
        var model = make.models[j];
        for (var k = 0; k < model.gens.length; k++) {
          if (model.gens[k].h === genH) {
            return { make: make.h, model: model.h, gen: genH };
          }
        }
      }
    }
    return null;
  }

  function initPicker(root, tree) {
    var selMake = root.querySelector("[data-fitment-make]");
    var selModel = root.querySelector("[data-fitment-model]");
    var selGen = root.querySelector("[data-fitment-gen]");
    var btnFind = root.querySelector("[data-fitment-find]");
    var btnReset = root.querySelector("[data-fitment-reset]");
    var current = root.querySelector("[data-fitment-current]");
    var collectionUrl = root.getAttribute("data-collection-url") || "/collections/all";

    var state = { make: null, model: null, gen: null };

    function makeNode() { return findBy(tree.makes, state.make); }
    function modelNode() {
      var m = makeNode();
      return m ? findBy(m.models, state.model) : null;
    }

    function sync() {
      fillSelect(selMake, tree.makes, selMake.getAttribute("data-placeholder"));
      selMake.value = state.make || "";
      var models = makeNode() ? makeNode().models : [];
      fillSelect(selModel, models, selModel.getAttribute("data-placeholder"));
      selModel.disabled = !state.make;
      selModel.value = state.model || "";
      var gens = modelNode() ? modelNode().gens : [];
      fillSelect(selGen, gens, selGen.getAttribute("data-placeholder"));
      selGen.disabled = !state.model;
      selGen.value = state.gen || "";
      btnFind.disabled = !state.gen;

      if (current) {
        if (state.gen) {
          var gen = findBy(modelNode().gens, state.gen);
          current.textContent = "Your vehicle: " + makeNode().n + " " + modelNode().n +
            (gen ? " " + gen.n : "");
          current.hidden = false;
        } else {
          current.hidden = true;
        }
      }
    }

    selMake.addEventListener("change", function () {
      state = { make: selMake.value || null, model: null, gen: null };
      sync();
    });
    selModel.addEventListener("change", function () {
      state.model = selModel.value || null;
      state.gen = null;
      sync();
    });
    selGen.addEventListener("change", function () {
      state.gen = selGen.value || null;
      if (state.gen) saveVehicle(state);
      sync();
    });
    btnFind.addEventListener("click", function () {
      if (!state.gen) return;
      saveVehicle(state);
      window.location.href = collectionUrl.replace(/\/$/, "") + "/fit_" + state.gen;
    });
    if (btnReset) {
      btnReset.addEventListener("click", function () {
        state = { make: null, model: null, gen: null };
        saveVehicle(null);
        sync();
        if (window.location.pathname.indexOf("/fit_") !== -1) {
          window.location.href = collectionUrl;
        }
      });
    }

    var fromUrl = vehicleFromPath(tree);
    if (fromUrl) {
      state.make = fromUrl.make;
      state.model = fromUrl.model;
      state.gen = fromUrl.gen;
      saveVehicle(state);
      sync();
      return;
    }
    var saved = readVehicle();
    if (saved && findBy(tree.makes, saved.make)) {
      state.make = saved.make;
      if (modelNodeFor(saved)) {
        state.model = saved.model;
        if (findBy(modelNodeFor(saved).gens, saved.gen)) state.gen = saved.gen;
      }
    }
    function modelNodeFor(v) {
      var m = findBy(tree.makes, v.make);
      return m ? findBy(m.models, v.model) : null;
    }
    sync();
  }

  function boot() {
    var pickers = document.querySelectorAll("[data-fitment-picker]");
    if (!pickers.length) return;
    // Источник справочника: window.LiftProVehicles (Storefront API -> fallback JSON)
    var loader = window.LiftProVehicles ? window.LiftProVehicles.load() :
      fetch(pickers[0].getAttribute("data-tree-url")).then(function (r) { return r.json(); });
    loader.then(function (tree) {
        pickers.forEach(function (p) { initPicker(p, tree); });
      })
      .catch(function (e) {
        console.error("LiftPro fitment: cannot load vehicle tree", e);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
